/* =====================================================
   assets/how-it-works-2026.js
   NuFace 2026 Redesign — How It Works video controller
   MS 2026-05-18

   - Pause/play toggle button
   - Auto-pause when section scrolls offscreen (perf + battery)
   - Re-initialises inside Shopify theme editor
   ===================================================== */

(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.hiwInited === '1') return;
    section.dataset.hiwInited = '1';

    var video = section.querySelector('video.how-it-works-2026__video');
    var pauseBtn = section.querySelector('[data-hiw-pause]');
    if (!video || !pauseBtn) return;

    var autoplay = section.dataset.autoplay === 'true';
    var userPaused = !autoplay;

    function setBtnState(paused) {
      pauseBtn.setAttribute('aria-pressed', String(paused));
      pauseBtn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }

    pauseBtn.addEventListener('click', function () {
      if (video.paused) {
        var p = video.play();
        if (p && p.catch) p.catch(function () { /* autoplay blocked or other */ });
        userPaused = false;
        setBtnState(false);
      } else {
        video.pause();
        userPaused = true;
        setBtnState(true);
      }
    });

    /* Pause when offscreen, resume when back (unless user explicitly paused) */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!userPaused && video.paused) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            }
          } else {
            if (!video.paused) video.pause();
          }
        });
      }, { threshold: 0.15 });
      io.observe(section);
    }

    /* Keep button state in sync if video pauses/plays for any other reason */
    video.addEventListener('pause', function () { setBtnState(true); });
    video.addEventListener('play',  function () { setBtnState(false); });
  }

  function initAll(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('.how-it-works-2026');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Re-init when a section is added/edited in the theme editor */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
